/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CareFindrConfig } from '../models/care-findr-config';

@Injectable({
  providedIn: 'root',
})
export class CareFindrConfigApiService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getCareFindrTenantConfig
   */
  static readonly GetCareFindrTenantConfigPath = '/carefindr-config-api/{tenant}';

  /**
   * GET Tenant Config settings stored in MongoDB.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCareFindrTenantConfig()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCareFindrTenantConfig$Response(params: {

    /**
     * The tenant name we will use as a key to lookup their config in MongoDB. Falls-back to default config if specified tenant not found.
     */
    tenant: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<CareFindrConfig>> {

    const rb = new RequestBuilder(this.rootUrl, CareFindrConfigApiService.GetCareFindrTenantConfigPath, 'get');
    if (params) {
      rb.path('tenant', params.tenant, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json; charset&#x3D;utf-8',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CareFindrConfig>;
      })
    );
  }

  /**
   * GET Tenant Config settings stored in MongoDB.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCareFindrTenantConfig$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCareFindrTenantConfig(params: {

    /**
     * The tenant name we will use as a key to lookup their config in MongoDB. Falls-back to default config if specified tenant not found.
     */
    tenant: string;
  },
  context?: HttpContext

): Observable<CareFindrConfig> {

    return this.getCareFindrTenantConfig$Response(params,context).pipe(
      map((r: StrictHttpResponse<CareFindrConfig>) => r.body as CareFindrConfig)
    );
  }

}
